import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Typography, IconButton } from "@material-ui/core";
import { Skeleton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { White } from "../../shared/styles/colors";
import PageResultResponse from "../../model/page-result-response";
import ApiService from "../../service/ApiService";
import Gallery from "../../model/gallery";
import Pathnames from "../../model/enum/pathnames";
import useStyles from "./styles";
import Misc from "../../utils/Misc";

const NR_ITEMS = 4;

const Recent = () => {
  const classes = useStyles();
  const [recents, setRecents] = useState<Gallery[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      await ApiService.get<PageResultResponse>(
        `frontend/galleryRecents?page=1&rowsPerPage=16&sortColumn=createdAt&sortDirection=asc`
      )
        .then((res) => {
          if (Misc.isArrayEmpty(res.items)) return;
          setRecents(res.items);
        })
        .finally(async () => {
          setLoading(false);
        });
    };

    if (Misc.isArrayEmpty(recents)) fetch();
  }, [recents]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - NR_ITEMS < 0
        ? Math.max(0, recents.length - NR_ITEMS)
        : prevIndex - NR_ITEMS
    );
  };

  const nextSlide = () => {
    setLoading(true);
    setCurrentIndex((prevIndex) =>
      prevIndex + NR_ITEMS >= recents.length ? 0 : prevIndex + NR_ITEMS
    );
    setLoading(false);
  };

  const visibleReviews = recents.slice(currentIndex, currentIndex + NR_ITEMS);

  // useEffect(() => {
  //   if (window.screen.width < 1340) {
  //     visibleReviews.length = Math.min(visibleReviews.length, 3);
  //   }
  // }, [window.screen.width]);

  return (
    <div className={classes.recentWorkContainer}>
      <Typography className={classes.recentWorkTitle}>
        Our most recent projects
      </Typography>
      <div className={classes.recentWorkCarrousel}>
        <IconButton
          onClick={prevSlide}
          className={classes.prevNextButton}
          style={{ right: -20 }}
          disabled={recents.length <= NR_ITEMS}
        >
          <ChevronLeft fontSize="medium" style={{ color: White }} />
        </IconButton>

        {loading ? (
          <Skeleton variant="rectangular" width={350} height={400} />
        ) : (
          <>
            {visibleReviews.map((item, index) => (
              <img
                src={item.imageUrl}
                alt="recent work"
                key={index}
                className={classes.recentWorkImage}
                loading="lazy"
              />
            ))}
          </>
        )}

        <IconButton
          onClick={nextSlide}
          className={classes.prevNextButton}
          style={{ left: -20 }}
          disabled={recents.length <= NR_ITEMS}
        >
          <ChevronRight fontSize="medium" style={{ color: White }} />
        </IconButton>
      </div>

      <div className={classes.carouselDots}>
        {Array(Math.ceil(recents.length / NR_ITEMS))
          .fill(0)
          .map((_, i) => (
            <span
              key={i}
              className={`${classes.dot} ${
                currentIndex / NR_ITEMS === i ? "active" : ""
              }`}
              onClick={() => setCurrentIndex(i * NR_ITEMS)}
            />
          ))}
      </div>

      <div className={classes.recentButtonContainer}>
        <Typography
          className={classes.recentDiv1}
          onClick={() => navigate(Pathnames.GALLERY)}
        >
          See more
        </Typography>
      </div>
    </div>
  );
};

export default Recent;
